import React, { type FC } from 'react';

export const FewTicketsLeftSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <path
                d="M10.7904 8.16666C10.7904 10.2083 9.25386 11.9583 6.9987 11.9583C4.74354 11.9583 3.20703 10.2083 3.20703 8.16666C3.20703 7.12153 3.79036 5.54167 5.2487 4.66667C5.2487 6.41667 5.2487 8.05 6.41536 7.58333C7.99192 6.95271 4.66536 4.08333 6.9987 1.75C8.16536 5.54167 10.7904 5.25 10.7904 8.16666Z"
                fill="#3A3247"
            />
        </svg>
    );
};
